import { render, staticRenderFns } from "./ChatActions.vue?vue&type=template&id=117cd6df&scoped=true&"
import script from "./ChatActions.vue?vue&type=script&lang=js&"
export * from "./ChatActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cd6df",
  null
  
)

export default component.exports